import { deadline, htmlFormFieldCharacterLimit, massSelect, providerSelect } from '@/platform/controls/element-plus/custom-validations';

export default {
	isAwardedMultipleTimes: [{ required: true, message: 'Required field', trigger: 'blur' }],
	grantDescription: [{ required: true, message: 'Required field', trigger: 'blur' }],

	destinationCountries: [{ required: true, validator: massSelect, trigger: 'none' }],
	destinationStates: [{ required: false, validator: massSelect, trigger: 'none' }],
	originCountries: [{ required: true, validator: massSelect, trigger: 'none' }],
	originStates: [{ required: false, validator: massSelect, trigger: 'none' }],
	disciplines: [{ required: true, validator: massSelect, trigger: 'none' }],

	summary: [{ required: true, validator: htmlFormFieldCharacterLimit, trigger: 'blur', max: 400 }],
	description: [{ required: true, validator: htmlFormFieldCharacterLimit, trigger: 'blur', max: 1500 }],
	eligibility: [{ required: true, validator: htmlFormFieldCharacterLimit, trigger: 'blur', max: 1500 }],
	benefits: [{ required: true, validator: htmlFormFieldCharacterLimit, trigger: 'blur', max: 960 }],
	applicationInfo: [{ required: false, validator: htmlFormFieldCharacterLimit, trigger: 'blur', max: 960 }],
	title: [{ required: true, trigger: 'blur', max: 100 }],
	provider: [{ required: true, validator: providerSelect, trigger: 'none' }],
	sourceUrl: [{ required: true , trigger: 'blur', max: 500}],
	foundAtUrl: [{ required: false, trigger: 'blur', max: 500}],
	applicationFormUrl: [{ required: false, trigger: 'blur', max: 500}],

	deadline: [{ required: true, validator: deadline, trigger: 'none' }],
};
